"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationPeriod = void 0;
var CommonEvaluationPeriods;
(function (CommonEvaluationPeriods) {
    CommonEvaluationPeriods["last_5m"] = "last_5m";
    CommonEvaluationPeriods["last_10m"] = "last_10m";
    CommonEvaluationPeriods["last_15m"] = "last_15m";
    CommonEvaluationPeriods["last_30m"] = "last_30m";
    CommonEvaluationPeriods["last_1h"] = "last_1h";
    CommonEvaluationPeriods["last_2h"] = "last_2h";
    CommonEvaluationPeriods["last_4h"] = "last_4h";
    CommonEvaluationPeriods["last_8h"] = "last_8h";
    CommonEvaluationPeriods["last_1d"] = "last_1d";
    CommonEvaluationPeriods["last_2d"] = "last_2d";
    CommonEvaluationPeriods["last_5d"] = "last_5d";
    CommonEvaluationPeriods["last_7d"] = "last_7d";
    CommonEvaluationPeriods["last_14d"] = "last_7d";
    CommonEvaluationPeriods["last_30d"] = "last_30d";
    CommonEvaluationPeriods["last_1mo"] = "last_1mo";
    CommonEvaluationPeriods["last_2mo"] = "last_2mo";
    CommonEvaluationPeriods["last_1y"] = "last_1y";
})(CommonEvaluationPeriods || (CommonEvaluationPeriods = {}));
exports.EvaluationPeriod = { ...CommonEvaluationPeriods };
//# sourceMappingURL=evaluationPeriod.js.map